import { useCallback, useState } from 'react';
import { IPagination } from 'hooks/use-table/use-table.props';

const usePagination = (defaultPagination: IPagination = defaultPaging) => {
  const [pagination, setPagination] = useState<IPagination>(defaultPagination);

  const pageChangeHandler = useCallback(
    (page: number) => {
      setPagination(pagination => ({
        ...pagination,
        start: page
      }));
    },
    [setPagination]
  );

  return { pagination, pageChangeHandler };
};

const defaultPaging = {
  start: 1,
  number: 10
};

export default usePagination;
